import { YesNoOptionID } from '@caresend/types';
import { getStore } from '../store/helpers/initStore.js';

/**
 * Given a sample, return a computed `ExtendedSample` object for use in
 * the frontend.
 */
const getExtendedSample = (sample) => {
    var _a, _b;
    const store = getStore();
    const supply = (_a = store.state.variables.variables) === null || _a === void 0 ? void 0 : _a.supplies[sample.supplyID];
    if (!supply)
        return;
    return {
        ...sample,
        color: supply.color,
        imageColor: supply.imageColor,
        name: supply.name,
        noScanAfterCollection: !!supply.noScanAfterCollection,
        orderWeight: (_b = supply.orderWeight) !== null && _b !== void 0 ? _b : 0,
        // questions: getQuestionsForSample(sample),
    };
};
[
    {
        id: YesNoOptionID.YES,
        label: 'I completely filled this {{ sampleContainerName }}',
    },
    {
        id: YesNoOptionID.PARTIAL,
        label: 'I partially filled this {{ sampleContainerName }}',
    },
    {
        id: YesNoOptionID.NO,
        label: 'I was unable to collect any sample in this {{ sampleContainerName }}',
    },
];

export { getExtendedSample };
